var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Edit/M/Default"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4,7.34 L16.66,4.6 C15.9197239,3.90465395 14.7758233,3.8745513 14,4.53 L5,13.53 C4.67676568,13.8559651 4.4755046,14.2832035 4.43,14.74 L4,18.91 C3.97272602,19.2065447 4.07903692,19.4998162 4.29,19.71 C4.47871883,19.8971865 4.73419702,20.0015368 5,20.0000167 L5.09,20.0000167 L9.26,19.62 C9.71679646,19.5744954 10.1440349,19.3732343 10.47,19.05 L19.47,10.05 C20.19729,9.2816618 20.1659864,8.06976648 19.4,7.34 Z M9.08,17.62 L6.08,17.9 L6.35,14.9 L12,9.32 L14.7,12.02 L9.08,17.62 Z M16,10.68 L13.32,8 L15.27,6 L18,8.73 L16,10.68 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon_pencil.2375a601.svg";
export { ForwardRef as ReactComponent };